import * as className from 'classnames'
import * as React from 'react'

interface IEntityBottomPanelBtnProps {
  children?: any
  isActive: boolean
  onKeyPress?: (e: any) => void
  onClick?: (e: any) => void
  className?: string
  disabled?: boolean
}

const EntityBottomPanelBtn = (props: IEntityBottomPanelBtnProps) => {
  const style = className(
    `rounded py1 bg-green bold font-white cursor--pointer flex items-center justify-center g-gap10 ${props.className}`,
    { 'bg-green': props.isActive },
    { 'bg-light-green': !props.isActive }
  )
  const onClick = (e: any) => {
    if (props.disabled) {
      return
    }
    if (props.onClick) {
      props.onClick(e)
    }
  }
  const onKeyPress = (e: any) => {
    if (props.disabled) {
      return
    }
    if (props.onKeyPress) {
      props.onKeyPress(e)
    }
  }
  return (
    <div className={`${style} entity-bottom-panel-btn`} onClick={onClick} onKeyPress={onKeyPress}>
      {props.children}
    </div>
  )
}

export default EntityBottomPanelBtn



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityBottomPanelBtn.tsx